import { checkboxField, dropdownField, inputField } from '@/ui/components/form';
import { t } from '@/ui/i18n/i18n';
import { ComputedRef, Ref, h } from 'vue';
import { SsoConfiguration } from '@/entities/sso-configuration';
import { Task } from '@/ui/concerns';
import { ValidationError } from '@/entities/validation';
import { SelectOptions } from '@/ui/types';
import { user } from '@/ui/auth/auth';
import { SeeErrorLogsLink } from '@/ui/pages/sso/SeeErrorLogsLink';

export const ScimFormFields = (
  record: Ref<SsoConfiguration>,
  validationErrors: ComputedRef<ValidationError[]>,
  task: Task,
  roleOptions: Ref<SelectOptions>,
  isScimConfirmationModalRequired: Ref<boolean>,
  isErrorLogsModalOpen: Ref<boolean>,
) => {
  return [
    checkboxField(
      {
        name: 'scimEnabled',
        label: t('sso.scim.enable'),
        value: record.value.scimEnabled,
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        record.value.scimEnabled = value;
        isScimConfirmationModalRequired.value = true;
      },
    ),

    record.value.scimEnabled && [
      inputField(
        {
          name: 'baseUri',
          label: t('sso.scim.scim-base-uri'),
          tooltipText: t('sso.tooltips.scim-base-uri'),
          tooltipAppendToBody: true,
          value: `${process.env.VUE_APP_API_URL}/v2/sso/scim/${user.value.organization.id}`,
          disabled: false,
          readonly: true,
          required: false,
          placeholder: '',
          errors: validationErrors.value,
        },
        () => {},
      ),
      inputField(
        {
          name: 'scimAccessKey',
          label: t('sso.scim.scim-access-key'),
          tooltipText: t('sso.tooltips.scim-access-key'),
          tooltipAppendToBody: true,
          value: record.value.scimAccessKey || '',
          placeholder: t('sso.scim.scim-access-key-placeholder'),
          required: true,
          errors: validationErrors.value,
          disabled: task.state.value.pending,
        },
        value => {
          record.value.scimAccessKey = value;
          isScimConfirmationModalRequired.value = true;
        },
      ),
      checkboxField(
        {
          name: 'scimRoleMappingEnabled',
          label: t('sso.scim.scim-enable-role-mapping'),
          value: record.value.scimRoleMappingEnabled,
          required: true,
          errors: validationErrors.value,
          disabled: task.state.value.pending,
        },
        value => {
          record.value.scimRoleMappingEnabled = value;
          isScimConfirmationModalRequired.value = true;
        },
      ),

      record.value.scimRoleMappingEnabled && [
        inputField(
          {
            name: 'scimSchemaNamespace',
            label: t('sso.scim.scim-schema-namespace'),
            value: record.value.scimSchemaNamespace || '',
            placeholder: t('sso.scim.scim-schema-namespace-placeholder'),
            required: true,
            errors: validationErrors.value,
            disabled: task.state.value.pending,
          },
          value => {
            record.value.scimSchemaNamespace = value;
            isScimConfirmationModalRequired.value = true;
          },
        ),
        inputField(
          {
            name: 'scimGroupAttribute',
            label: t('sso.scim.scim-group-attribute'),
            value: record.value.scimGroupAttribute || '',
            placeholder: t('sso.scim.scim-group-attribute-placeholder'),
            required: true,
            errors: validationErrors.value,
            disabled: task.state.value.pending,
          },
          value => {
            record.value.scimGroupAttribute = value;
            isScimConfirmationModalRequired.value = true;
          },
        ),
        dropdownField(
          {
            name: 'defaultRole',
            label: t('sso.default-role'),
            tooltipText: t('sso.tooltips.default-role'),
            value: record.value.defaultRole,
            placeholder: t('sso.default-role-placeholder'),
            required: false,
            options: roleOptions.value,
            errors: validationErrors.value,
            disabled: task.state.value.pending,
          },
          value => {
            record.value.defaultRole = value || null;
            isScimConfirmationModalRequired.value = true;
          },
        ),
      ],
      h(SeeErrorLogsLink, {
        on: {
          click(e: MouseEvent) {
            e.preventDefault();
            isErrorLogsModalOpen.value = true;
          },
        },
      }),
    ],
  ];
};
